import apiClient from "../../utils/apiclient";



export const getallusers=async(reqBody:{
    locations: string[];
    outlet_type:string[];
    page:string;
    limit:string;
    search:string
    task_id:string | undefined
 },token:string)=>{
   return await apiClient.post('/cohorts/get-total-users',reqBody,{
      headers:{
         Authorization: `Bearer ${token}`
      }
   })
 
   




 }






export const fetchCohortFilterOptions = async (filters: any, token: string) => {
  try {
    const response = await apiClient.post(
      '/cohorts/Asmanamesrejions',
      filters,
      {
        headers:{
         Authorization: `Bearer ${token}`
      }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching cohort filter options:', error);
    throw error;
  }
};


export const getalltaskbyid=async(reqBody:{
   task_id: string;
},token:string)=>{
  return await apiClient.post('/admin/task/getall-task-byid-v2',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })

  
}
 
export const getalllocations=async()=>{
    return await apiClient.get('/city/distinctcity',{
     
    })
 }

 export const getalltasktype=async()=>{
   return await apiClient.get('/reports/getting_tasktype_dropdown',{
    
   })
}

  
export const getalloutlettype=async()=>{
    return await apiClient.get('/cohorts/paid-unpaid-dropdown',{
     
    })
 }

 export const getalloutletname=async()=>{
    return await apiClient.get('/cohorts/get_outlet_names',{
     
    })
 }
 export const fetchpmient=async()=>{
    return await apiClient.get('/cohorts/fetch_pmi_entity',{
     
    })
 }
 
 
export const getalloutlettypes=async()=>{
    return await apiClient.get('/reportfe/paid_unpaid_dropdown',{
     
    })
 }

 export const getalloutletnames=async()=>{
    return await apiClient.get('/reportfe/get-outlet-names',{
     
    })
 }
 export const fetchpmienti=async()=>{
    return await apiClient.get('/reportfe/fetch-pmi-entity',{
     
    })
 }



 export const createcohorts=async(reqBody:{
   locations: string[];
   outlet_type:string[];
   cohortName:string;
   task_id:string
  
},token:string)=>{
  return await apiClient.post('/cohorts/create-cohort',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
 
}



export const editcohorts=async(reqBody:{
   locations: string[];
   outlet_type:string[];
   cohortName:string;
   cohort_id:string
  
},token:string)=>{
  return await apiClient.post('/cohorts/update_Cohort',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
 
}

export const assignusers=async(reqBody:{
   task_id: string;
   user_ids:string[];
  
  
},token:string)=>{
  return await apiClient.post('/admin/task/assign-task',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
 
}
export const getuserretailers=async(reqBody:{
   cohort_id: string;
   search:String,
   page:string,
   limit:string

  
  
},token:string)=>{
  return await apiClient.post('/cohorts/get_all_cohortsusers',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })

}
export const viewcohorts = async (
   reqBody: { search: string; page: string; limit: string },
   token: string
 ) => {
   return await apiClient.post('/cohorts/viewcohorts', reqBody, {
     headers: {
       Authorization: `Bearer ${token}`,
     },
   });
 };
 
 
 export const approvaldurations = async (
   reqBody: { task_id: string; end_date: string },
   token: string
 ) => {
   return await apiClient.post('/admin/task/approval_task_durataions_v1', reqBody, {
     headers: {
       Authorization: `Bearer ${token}`,
     },
   });
 };
 


export const getcohort=async(reqBody:{
   cohort_id: string;
   
   page:string;
   limit:string;
  
},token:string)=>{
  return await apiClient.post('/cohorts/get-cohort',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })

}





   export const deletecohort=async(reqBody:{
      cohort_id: string;
   },token:string)=>{
     return await apiClient.post('/cohorts/delete_Cohort',reqBody,{
        headers:{
           Authorization: `Bearer ${token}`
        }
     })
   
   }
     export const viewretailers=async(reqBody:{
      locations: string[];
      outlet_type:string[]
         search: string;
         page: string,
         limit: string,
        
     },token:string)=>{
        return await apiClient.post('/admin/task/view_retailers_v1',reqBody,{
           headers:{
              Authorization: `Bearer ${token}`
           }
        })
     
     
  

  }


export const getexportretailers = async (
  cohort_id: string,
  token: string,
  search: string = ""
) => {
  return await apiClient.get(
    `/reports/generate-excel-sheets-for-cohort?cohort_id=${cohort_id}&search=${search}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob", // <-- important for Excel
    }
  );
};

export const getTotalUsersExport = async (
  token: string,
  locations: string,
  selecteduserids: string = "",
  search: string = "",
  outlet_type: string = "",
  task_id?: string
) => {
  return await apiClient.get(
    `/cohorts/get-total-users-export?search=${search}&outlet_type=${outlet_type}&task_id=${task_id}&locations=${locations}&selecteduserids=${selecteduserids}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob", // important for Excel
    }
  );
};



export const staticcsvcohort = async (
  formData: FormData,
  token: string
) => {
  return await apiClient.post("/cohorts/static-csv-cohort", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data", // Required for file uploads
    },
  });
};
export const gettaskData=async(reqBody:{
    task_id: string;
   
 },token:string)=>{
   return await apiClient.post('/admin/task/gettaskData',reqBody,{
      headers:{
         Authorization: `Bearer ${token}`
      }
   })
 
 }
